export default {
	emailHeader: "We currently require sign-up with Google or Microsoft.",
	emailInstruction: "Enter your email to be notified when email-based sign-up is available.",
	emailFieldLabel: "Email",
	emailFieldPlaceholder: "e.g. alex{'@'}business.com",
	emailButtonText: "Notify me",
	emailConfirmationTitle: "Thanks for letting us know you're interested.",
	emailConfirmationInstruction: "We'll notify you as soon as email-based sign-up is available.",
};
